import { useRef, useState } from "react";
import { ImageProps } from "next/image";
import { YouTubeProps, YouTubePlayer } from "react-youtube";
import { video } from "./video.variants";

export type UseVideoProps = {
  className?: string;
  cover: ImageProps["src"];
  title: string;
  videoId: string;
};

export const useVideo = (props: UseVideoProps) => {
  const { className = "", cover, title, videoId } = props;
  const [playing, setPlaying] = useState(false);
  const ref = useRef<YouTubePlayer>(null);

  const styles = video({ playing });

  const opts: YouTubeProps["opts"] = {
    playerVars: {
      controls: 0,
      iv_load_policy: 3,
      listType: "user_uploads",
      rel: 0,
      modestbranding: 1,
      showinfo: 0,
    },
  };

  const onClick = () => {
    const player = ref.current;

    if (!player) return;

    if (playing) {
      player.getInternalPlayer().pauseVideo();
    } else {
      player.getInternalPlayer().playVideo();
    }
  };

  const onPlay: YouTubeProps["onPlay"] = () => {
    setPlaying(true);
  };

  const onEnd: YouTubeProps["onEnd" | "onPause"] = () => {
    setPlaying(false);
  };

  return {
    styles,
    className,
    ref,
    opts,
    onClick,
    onPlay,
    onEnd,
    cover,
    title,
    videoId,
  };
};
